import { useState } from 'react';
import { useWatch } from 'react-hook-form';

import Combobox, { useFilteredCollection } from 'ui/Combobox';
import Field from 'ui/Field';

import { useSankeyFormContext } from '../../../../contexts/sankeyFormContext';
import { SankeyFlow } from '../../../../diagram/types';
import { useTeamContext } from '../../../../utils/team';
import { useSankeyFlowInteraction } from '../../../SankeyInteractionProvider/utils';
import { updateFlowNode, useAllNodeNames } from './utils';

type Props = {
  flow: SankeyFlow;
  field: 'source' | 'target';
  label?: string;
};

const FlowNodeAutocomplete: React.FC<Props> = ({ flow, field, label }) => {
  const { form } = useSankeyFormContext();
  const { teamSettings } = useTeamContext();
  const { handleBlur } = useSankeyFlowInteraction(flow);

  const nodeNames = useAllNodeNames();
  const selectedValue = useWatch({
    control: form.control,
    name: `flows.${flow.id}.${field}`,
  });
  const [inputValue, setInputValue] = useState(selectedValue);
  const filteredCollection = useFilteredCollection(
    nodeNames,
    inputValue,
    selectedValue
  );

  return (
    <Field label={label} fontSize="xs">
      <Combobox.Root
        size="sm"
        collection={filteredCollection}
        inputValue={inputValue}
        onInputValueChange={(e) => setInputValue(e.inputValue)}
        value={[selectedValue]}
        onValueChange={(e) => {
          handleBlur();
          updateFlowNode(form, flow.id, field, e.value[0], teamSettings);
        }}
      >
        <Combobox.Input minH={8} />
        <Combobox.Content maxH="200px">
          {filteredCollection.items.map((item) => (
            <Combobox.Item
              key={item.value}
              isCreatable={!nodeNames.includes(item.value)}
              item={item}
            />
          ))}
        </Combobox.Content>
      </Combobox.Root>
    </Field>
  );
};

export default FlowNodeAutocomplete;
